import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import CaseNotesPageQuery from './__generated__/CaseNotesPageQuery$parameters';
import type { CaseNotesPageQuery as CaseNotesPageQueryType } from './__generated__/CaseNotesPageQuery.graphql.ts';

type CaseNotesEntryPointComponent = EntryPointComponent<
	{ page: CaseNotesPageQueryType },
	{},
	{},
	{} | null
>;

export const caseNotesEntryPoint: EntryPoint<CaseNotesEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<CaseNotesEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-case-management-settings-case-notes" */ './CaseNotesPage.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
			queries: {
				page: {
					parameters: CaseNotesPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey ?? '',
					},
				},
			},
		}),
	});
